package link.erpango.quip.data.remote.repository

import link.erpango.quip.data.remote.ApiClient
import link.erpango.quip.data.remote.repository.auth.AuthRepository
import link.erpango.quip.data.remote.repository.garage.GarageRepository
import link.erpango.quip.data.remote.repository.maintenance.MaintenanceRepository
import link.erpango.quip.data.remote.repository.user.UserRepository
import link.erpango.quip.data.remote.repository.catalog.CatalogRepository
import link.erpango.quip.data.remote.repository.myspareparts.MySparePartsRepository
import link.erpango.quip.data.remote.repository.extraction.ExtractionRepository

class RemoteDataSource(
    api: ApiClient,
): IRemoteDataSource {
    override val auth = AuthRepository(api)
    override val user = UserRepository(api)
    override val garage = GarageRepository(api)
    override val maintenance = MaintenanceRepository(api)
    override val catalog = CatalogRepository(api)
    override val mySpareParts = MySparePartsRepository(api)
    override val extraction = ExtractionRepository(api)
}